module.exports = __webpack_public_path__ + "img/img-yu-wang.6c1a9715.png";